import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const parseAmount = (d, it) => {
  if (d.amount === undefined) return it.amount;
  return d.amount === "" ? null : Number(String(d.amount).replace(/[^0-9.-]/g, ""));
};
const parseDays = (d, it) => {
  if (d.days === undefined) return it.days;
  return d.days === "" ? null : parseInt(d.days, 10);
};

export function useCorPricing(runId) {
  const [co, setCo] = useState(null);
  const [draft, setDraft] = useState({});
  const load = useCallback(() => api.get(`/reviews/${runId}/change-order`).then((r) => { setCo(r.data); setDraft({}); }), [runId]);
  useEffect(() => { load(); }, [load]);
  const val = (it, k) => (draft[it.finding_id]?.[k] !== undefined ? draft[it.finding_id][k] : (it[k] ?? ""));
  const edit = (it, k, v) => setDraft({ ...draft, [it.finding_id]: { ...(draft[it.finding_id] || {}), [k]: v } });
  const save = async (it) => {
    const d = draft[it.finding_id];
    if (!d) return;
    const amount = parseAmount(d, it);
    const days = parseDays(d, it);
    const note = d.estimator_note !== undefined ? d.estimator_note : it.estimator_note;
    if (amount !== null && Number.isNaN(amount)) return toast.error("Enter a valid dollar amount");
    try { await api.patch(`/findings/${it.finding_id}/pricing`, { cor_amount: amount, cor_days: Number.isNaN(days) ? null : days, cor_note: note || null }); await load(); } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };
  return { co, val, edit, save };
}
